import dayjs from 'dayjs';

const LOCAL_DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Serializes a date as a local calendar date (YYYY-MM-DD),
 * without the UTC shift that toISOString() would introduce.
 */
export function toLocalDateString(date: Date | null): string {
  if (!date) return '';

  return dayjs(date).format(LOCAL_DATE_FORMAT);
}

/**
 * Parses a date-only or datetime string into a Date in local time.
 */
export function parseLocalDate(value: string | null | undefined): Date | null {
  if (!value) return null;

  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.toDate() : null;
}
